import axios from './authService';
import API_ENDPOINTS from '../config/apiConfig';

const unwrap = (response) => response.data;

// Start unused Locator Drift scenario runner services.
// Retained for the non-batch runner flow, although the current LocatorDriftPage UI does not render it.
export async function checkLocatorApiHealth() {
  const response = await axios.get(API_ENDPOINTS.LOCATOR_DRIFT_HEALTH);
  return unwrap(response);
}

export async function fetchLocatorFlows() {
  const response = await axios.get(API_ENDPOINTS.LOCATOR_DRIFT_FLOWS);
  return unwrap(response);
}

export async function runLocatorScenario(flowId, scenarioId, platform) {
  const response = await axios.post(API_ENDPOINTS.LOCATOR_DRIFT_RUN_SCENARIO(flowId, scenarioId), {
    platform,
  });
  return unwrap(response);
}

export async function fetchLocatorRun(runId) {
  const response = await axios.get(API_ENDPOINTS.LOCATOR_DRIFT_RUN(runId));
  return unwrap(response);
}

export async function fetchLocatorRunLogs(runId, fromIndex = 0) {
  const response = await axios.get(API_ENDPOINTS.LOCATOR_DRIFT_RUN_LOGS(runId, fromIndex));
  return unwrap(response);
}
// End unused Locator Drift scenario runner services.

export async function fetchLocatorDataFiles() {
  const response = await axios.get(API_ENDPOINTS.LOCATOR_DATA);
  return unwrap(response);
}

export async function fetchLocatorDataFile(filename) {
  const response = await axios.get(API_ENDPOINTS.LOCATOR_DATA_FILE(filename));
  return unwrap(response);
}

export async function deleteLocatorDataFile(filename) {
  const response = await axios.delete(API_ENDPOINTS.LOCATOR_DATA_FILE(filename));
  return unwrap(response);
}

export async function fetchScreenDriftGrouped() {
  const response = await axios.get(API_ENDPOINTS.LOCATOR_DATA_GROUPED);
  return unwrap(response);
}

export async function compareScreenDrift(payload) {
  const response = await axios.post(API_ENDPOINTS.COMPARE_SCREEN_DRIFT, payload);
  return unwrap(response);
}

export async function fetchAnalyticsDriftGrouped() {
  const response = await axios.get(API_ENDPOINTS.BEACON_DATA_GROUPED);
  return unwrap(response);
}

export async function compareAnalyticsDrift(payload) {
  const response = await axios.post(API_ENDPOINTS.COMPARE_ANALYTICS_DRIFT, payload);
  return unwrap(response);
}

export async function compareVersionDiff(payload) {
  const response = await axios.post(API_ENDPOINTS.COMPARE_VERSION_DIFF, payload);
  return unwrap(response);
}

export async function fetchBeaconPriorities() {
  const response = await axios.get(API_ENDPOINTS.BEACON_PRIORITIES);
  return unwrap(response);
}

export async function fetchDriftIgnoreList() {
  const response = await axios.get(API_ENDPOINTS.DRIFT_IGNORE);
  return unwrap(response);
}

export async function ignoreLocator(entry) {
  const response = await axios.post(API_ENDPOINTS.DRIFT_IGNORE, {
    type: 'locator',
    entry,
  });
  return unwrap(response);
}

export async function ignoreBeacon(beaconId) {
  const response = await axios.post(API_ENDPOINTS.DRIFT_IGNORE, {
    type: 'beacon',
    entry: { id: String(beaconId), reason: 'Manually ignored' },
  });
  return unwrap(response);
}

export async function fetchHealingStats() {
  const response = await axios.get(API_ENDPOINTS.HEALING_STATS);
  return unwrap(response);
}

export async function fetchHealingHistory(options = {}) {
  const response = await axios.get(API_ENDPOINTS.HEALING_HISTORY(options));
  return unwrap(response);
}

export async function resolveHealingEvent(eventId, outcome) {
  const response = await axios.patch(API_ENDPOINTS.HEALING_HISTORY_ITEM(eventId), {
    outcome,
  });
  return unwrap(response);
}

export async function runHealAll(payload) {
  const response = await axios.post(API_ENDPOINTS.HEAL_RUN, payload);
  return unwrap(response);
}
